import { Link } from '@/Framework/Router/Next/Link';

import logoWings from '@/Framework/assets/logo/logoWings.inline.svg';
import finsightLogoText from '@/Framework/assets/logo/finsightLogoText.inline.svg';

import styles from './logo.scss';

interface ILogoProps {
  onClick: () => void,
}
const Logo = ({ onClick }: ILogoProps) => (
  <Link
    to="/"
    dataTest="finsightLogoLink"
    className={ styles.logo }
    onClick={ onClick }
  >
    <i
      className={ styles.logoWings }
      dangerouslySetInnerHTML={ { __html: logoWings } }
    />
    <i
      className={ styles.logoCompanyName }
      dangerouslySetInnerHTML={ { __html: finsightLogoText } }
    />
  </Link>
);

export default Logo;
